import React from 'react';
import { Fragment } from 'react';
import Footer from '../../../components/footer';
import Head from '../../../components/head';
import Header from '../../../components/headerlogged';
import Solicitacao from '../../../components/user/solicitacao';


function HomeSolicitacaoScreen () {
    return (
        <Fragment>
            <Head titulo="Área de Solicitacao | Departamento de TI" />
            <Header />
            <Solicitacao />
            <Footer />
        </Fragment>
    );
}

export default HomeSolicitacaoScreen;